import Grid2 from '@mui/material/Grid2';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import CardIdentifierInput from './CardIdentifierInput';
import { CARD_READER_STATE, SOCKET_ERROR } from './const';
import InfoIconButton from './InfoIconButton';
import ReaderInfo from './ReaderInfo';
import ReadingButton from './ReadingButton';
import RefreshIconButton from './RefreshIconButton';
import useCardReader from './useCardReader';

interface ICardReader {
  showCardReaderButton?: boolean;
}

function CardReader({ showCardReaderButton = true }: ICardReader) {
  const { cardId, eraseCardId, error, readCard, status, testDriver } = useCardReader();
  const [isInfoOpen, setIsInfoOpen] = useState(false);
  const { getValues } = useFormContext();
  const value = getValues('card');

  useEffect(() => {
    if (value !== cardId) {
      eraseCardId();
    }
  }, [value]);

  const handleReading = () => readCard();

  const isDriverInitialized =
    [CARD_READER_STATE.DRIVER_AVAILABLE].includes(status) && ![SOCKET_ERROR.CONNECTION_DEVICE_ERR].includes(error);

  const isConnecting = [CARD_READER_STATE.CONNECT].includes(status);
  const isTesting = [CARD_READER_STATE.TEST].includes(status);
  const isReading = [CARD_READER_STATE.READING].includes(status);

  const isInitError =
    ([CARD_READER_STATE.DRIVER_UNAVAILABLE].includes(status) || [SOCKET_ERROR.CONNECTION_DEVICE_ERR].includes(error)) &&
    !value;

  const isRefreshButton =
    [CARD_READER_STATE.DRIVER_UNAVAILABLE].includes(status) ||
    [SOCKET_ERROR.CONNECTION_DEVICE_ERR, SOCKET_ERROR.CONNECTION_ERR].includes(error) ||
    isTesting;

  return (
    <Grid2 container direction="column" spacing={0} py={0}>
      <CardIdentifierInput
        cardId={cardId}
        error={error}
        isConnecting={isConnecting}
        isDriverInitialized={isDriverInitialized}
        isInitError={isInitError}
        isReading={isReading}
        isTesting={isTesting}
      />
      {showCardReaderButton && (
        <Grid2 alignItems="center" container direction="row" spacing={1}>
          <Grid2>
            <ReadingButton disabled={!isDriverInitialized} isLoading={isReading} onClick={handleReading} />
          </Grid2>
          <Grid2>
            <InfoIconButton onClick={() => setIsInfoOpen(!isInfoOpen)} />
          </Grid2>
          {isRefreshButton && (
            <Grid2>
              <RefreshIconButton disabled={isConnecting || isTesting || isReading} onClick={testDriver} />
            </Grid2>
          )}
        </Grid2>
      )}
      {isInfoOpen && (
        <Grid2>
          <ReaderInfo />
        </Grid2>
      )}
    </Grid2>
  );
}

export default CardReader;
